// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Css from "bs-css-emotion/src/Css.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as I18next$LiveRoom from "../../bindings/I18next.bs.js";
import * as CommonStyles$LiveRoom from "../../styles/CommonStyles.bs.js";
import * as SterlingModal$LiveRoom from "../../bindings/SterlingModal.bs.js";
import * as Button from "@sothebys/sterling/button";
import * as SterlingTypography$LiveRoom from "../../bindings/SterlingTypography.bs.js";
import * as AuctionRoomSharedContacts$LiveRoom from "../AuctionRoomSharedContacts.bs.js";

function ActionNeededPendingEnrollment$PhoneOrEmail(props) {
  var phoneNumber = props.phoneNumber;
  var email = props.email;
  var match = I18next$LiveRoom.useTranslation(undefined);
  var t = match.t;
  return React.createElement(SterlingTypography$LiveRoom.Paragraph16Regular.make, {
              children: null
            }, Curry._1(t, "Enrollment_toCompleteRegistration"), React.createElement(SterlingTypography$LiveRoom.Paragraph16LinkRegular.make, {
                  href: "tel:" + phoneNumber,
                  children: phoneNumber
                }), " " + Curry._1(t, "Common_or_string") + " ", React.createElement(SterlingTypography$LiveRoom.Paragraph16LinkRegular.make, {
                  href: "mailto:" + email,
                  children: email
                }));
}

var PhoneOrEmail = {
  make: ActionNeededPendingEnrollment$PhoneOrEmail
};

function ActionNeededPendingEnrollment(props) {
  var onClose = props.onClose;
  var match = AuctionRoomSharedContacts$LiveRoom.getBidDepartmentContactForAuctionLocation(props.location);
  var match$1 = I18next$LiveRoom.useTranslation(undefined);
  var t = match$1.t;
  return React.createElement(SterlingModal$LiveRoom.Modal.make, {
              children: null,
              className: Curry._1(Css.style, {
                    hd: CommonStyles$LiveRoom.mediaV2(/* TabletPortraitAndMobile */2, {
                          hd: Css.important(Css.maxHeight(Css.pct(100))),
                          tl: {
                            hd: Css.important(Css.maxWidth(Css.pct(100))),
                            tl: /* [] */0
                          }
                        }),
                    tl: /* [] */0
                  }),
              onClose: onClose,
              isOpen: true,
              headerTitle: Curry._1(t, "Common_actionNeeded")
            }, React.createElement(SterlingModal$LiveRoom.Content.make, {
                  children: React.createElement("div", undefined, React.createElement(SterlingTypography$LiveRoom.Paragraph16Regular.make, {
                            className: Curry._1(Css.style, {
                                  hd: Css.marginBottom(Css.px(16)),
                                  tl: /* [] */0
                                }),
                            children: Curry._1(t, "ActionNeededToBid_biddingNotice")
                          }), React.createElement(ActionNeededPendingEnrollment$PhoneOrEmail, {
                            email: match[0],
                            phoneNumber: match[1]
                          })),
                  className: Curry._1(Css.style, {
                        hd: Css.marginBottom(Css.px(16)),
                        tl: {
                          hd: Css.important(Css.padding3(Css.px(28), Css.px(40), "zero")),
                          tl: /* [] */0
                        }
                      })
                }), React.createElement(SterlingModal$LiveRoom.Footer.make, {
                  children: React.createElement(Button.Button, {
                        onClick: (function (param) {
                            Curry._1(onClose, undefined);
                          }),
                        className: Curry._1(Css.style, {
                              hd: Css.maxWidth(Css.px(184)),
                              tl: /* [] */0
                            }),
                        buttonStyle: "primaryNavy",
                        children: Curry._1(t, "Common_iUnderstand")
                      })
                }));
}

var make = ActionNeededPendingEnrollment;

export {
  PhoneOrEmail ,
  make ,
}
/* Css Not a pure module */
